export default __webpack_public_path__ + "static/media/CapaCentroOeste.9cd0231b.jpg";